<ion-button [color]="color" slot="" fill="outline" (click)="startReading()" [disabled]="to.disabled">
  <ion-icon slot="start" name="list"></ion-icon>  
  <ion-label>
    {{label}}
  </ion-label>
</ion-button>

<table #itemTable class="fullsize valuelist"></table>
